"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es7.string.pad-start");
var _request = _interopRequireDefault(require("@/utils/request"));
var _request2 = _interopRequireDefault(require("@/utils/request4"));
var _RestTable = _interopRequireDefault(require("@/components/RestTable.vue"));
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _formatMixin = require("@/utils/formatMixin");
var _fileSaver = _interopRequireDefault(require("file-saver"));
var _auth = require("@/utils/auth");
var _request3 = _interopRequireDefault(require("@/utils/request5"));
var _default = exports.default = {
  components: {
    RestTable: _RestTable.default,
    Pagination: _index.default
  },
  mixins: [_formatMixin.formatMixin],
  data: function data() {
    return {
      chargeform: {},
      currentName: '',
      //风控名称
      currentType: '',
      // 风控类型
      currentPrice: '',
      // 风控价格
      user_id: 0,
      user_info: {
        card_code: '',
        mobile: '',
        photoBack: '',
        photoFront: '',
        real_name: ''
      },
      // 顶部搜索框form数据
      formInline: {
        card_code: '',
        //搜索关键词
        real_name: '',
        mobile: '',
        remark: 'pay_risk_behavior,unify,court_detail_pro,apply_loan_c,apply_loan_c_money,financial_blacklist,fengkong_default_money',
        // 含3C/金融黑名单
        start_time: '',
        end_time: ''
      },
      //   dialogVisiblerisk: false,
      datenum: [],
      money: 0,
      // 商家余额
      moneyList: {
        count: 0
      },
      // 调用记录
      listQuery: {
        page: 1,
        page_size: 10
      },
      listLoading: false,
      deviceType: 'desktop',
      // 设备类型: mobile, tablet, desktop
      showPhoto: false,
      action: '/api/safe/posts/',
      document: {}
    };
  },
  created: function created() {
    if (this.$route.query.user_id) {
      console.log(this.$route.query.user_id);
      this.user_id = this.$route.query.user_id;
      this.getFengKongUser();
    } else {
      console.log('no user_id');
      this.getMoneyList();
    }
    this.getCharge();

    // 添加这一行来设置正确的action路径
    this.action = "".concat(process.env.VUE_APP_BASE_API, "/safe/posts/");
  },
  computed: {
    start_time: function start_time() {
      return this.datenum[0] ? this.formatDate(this.datenum[0]) : '';
    },
    end_time: function end_time() {
      return this.datenum[1] ? this.formatDate(this.datenum[1]) : '';
    }
  },
  mounted: function mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    // 确认上传图片
    uploadPhoto: function uploadPhoto() {
      var _this = this;
      // 都要传
      if (!this.user_info.photoBack || !this.user_info.photoFront) {
        this.$message({
          message: '请上传身份证正反面',
          type: 'warning'
        });
        return;
      }

      //  提示
      this.$confirm('确定要上传图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 提交图片
        (0, _request.default)({
          url: "/system/shopConfig/updateFengKongUser/",
          method: 'put',
          data: {
            shop_id: _this.$user.data.shop,
            id: _this.user_id,
            photoFront: _this.user_info.photoFront,
            photoBack: _this.user_info.photoBack
          }
        }).then(function (res) {
          if (res.code == 200) {
            _this.$message({
              message: '上传成功',
              type: 'success'
            });
            _this.showPhoto = false;

            // 重新获取用户信息
            _this.getFengKongUser();

            // 上传成功后自动调用征信查询
            // this.autoTriggerZhengxinQuery();
          } else {
            _this.$message({
              message: '上传失败，请重试',
              type: 'error'
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消上传'
        });
      });
    },
    // 上传成功后自动触发征信查询
    // autoTriggerZhengxinQuery() {
    //   // 确保是征信查询操作
    //   if (this.currentType === 'zhengxin_money') {
    //     // 设置查询名称和价格显示
    //     this.currentName = '征信调用';
    //     this.currentPrice = this.chargeform.zhengxin_money;
    //     // 直接调用查询接口
    //     const apiToken = getTokenInfo('apiToken')
    //     if (apiToken) {
    //       this.setfengkong(apiToken)
    //     } else {
    //       this.get_token()
    //     }
    //   }
    // },
    // 检测设备类型
    checkDevice: function checkDevice() {
      var clientWidth = document.documentElement.clientWidth;
      if (clientWidth <= 768) {
        this.deviceType = 'mobile';
      } else if (clientWidth <= 1024) {
        this.deviceType = 'tablet';
      } else {
        this.deviceType = 'desktop';
      }
    },
    getCharge: function getCharge() {
      var _this2 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getConfig/",
        method: 'get',
        params: {
          shop_id: this.$user.data.shop
        }
      }).then(function (response) {
        if (response.data) {
          _this2.chargeform = response.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_token: function get_token() {
      var _this3 = this;
      (0, _request3.default)({
        url: "/get_token",
        method: 'post',
        data: {
          key: this.chargeform.key,
          secret: this.chargeform.key_secret
        }
      }).then(function (res) {
        console.log(res);
        (0, _auth.setTokenInfo)('apiToken', res.token, 3);
        _this3.setfengkong(res.token);
      }).catch(function (err) {
        console.log(err);
      });
    },
    setfengkong: function setfengkong(token) {
      var _this4 = this;
      var url = "/risk/pay_risk_behavior";
      if (this.currentType == 'unify_money') {
        url = "/risk/unify";
      }
      if (this.currentType == 'score_pano_money') {
        url = "/risk/score_pano";
      }
      if (this.currentType == 'court_detail_pro_money') {
        url = "/risk/court_detail_pro";
      }
      if (this.currentType == 'apply_loan_c_money') {
        url = "/risk/apply_loan_c";
      }
      if (this.currentType == 'financial_blacklist_money') {
        url = "/risk/financial_blacklist";
      }
      if (this.currentType == 'fengkong_default') {
        url = "/risk/fengkong_default";
      }
      // if(this.currentType=='zhengxin_money'){

      //   if (this.user_info.photoBack && this.user_info.photoFront) {
      //     //   this.showPhoto = true
      //     //     return
      //       url = `/risk/create_zhengxin`
      //     } else {
      //     //   this.$message({
      //     //     message: '请上传身份证正反面',
      //     //     type: 'warning'
      //     //   })

      //       this.showPhoto = true

      //       return
      //     }
      // }
      (0, _request3.default)({
        url: url,
        method: 'post',
        headers: {
          "Token": token
        },
        data: {
          //   id:this.user_id,
          real_name: this.user_info.real_name,
          card_no: this.user_info.card_code,
          mobile: this.user_info.mobile
        }
      }).then(function (res) {
        if (res.code == 0 || res.code == "0" || res.code == 200) {
          // 法院等：未查得仍跳转详情，用 warning 提示
          if (res.hit === false || res.empty || res.msg && res.msg !== '成功') {
            var tip = res.msg || '数据库未查得';
            _this4.$message({
              message: res.hit === false || res.empty ? tip + '（本次查询已计费）' : tip,
              type: 'warning',
              duration: 6000
            });
          }
          if (_this4.currentType == 'fengkong_default') {
            _this4.$router.push({
              name: 'fengkongDefault',
              query: {
                id: res.record_id,
                type: _this4.currentType
              }
            });
          } else {
            _this4.$router.push({
              name: 'ReportTable',
              query: {
                id: res.record_id,
                type: _this4.currentType
              }
            });
          }
          _this4.getMoneyList();
        } else {
          _this4.$message({
            message: res.msg || '调用失败',
            type: 'error',
            duration: 6000
          });
          _this4.getMoneyList();
        }
      }).catch(function (err) {
        var msg = err && err.message ? err.message : '调用失败';
        if (msg && msg !== '请求出错') {
          _this4.$message({
            message: msg,
            type: 'error',
            duration: 6000
          });
        }
        _this4.getMoneyList();
      });
    },
    showfengkong: function showfengkong(name, type, price) {
      var _this5 = this;
      if (price <= 0) {
        this.$confirm("\u60A8\u6682\u672A\u5F00\u901A\u6B64\u67E5\u8BE2\u529F\u80FD\uFF0C\u8BF7\u8054\u7CFB\u8FD0\u884C\u8FDB\u884C\u5F00\u901A", '提示');
      } else {
        this.currentName = name;
        this.currentType = type;
        this.currentPrice = price;
        this.$confirm("\u786E\u5B9A\u8981\u67E5\u8BE2".concat(name, "\u5417\uFF1F\u67E5\u8BE2\u5C06\u6D88\u8017<span style=\"color: red; font-weight: bold;\">").concat(price, "\u8C46/\u6B21</span>"), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(function () {
          // 此处调用风控查询接口,调用成功清空数据
          var apiToken = (0, _auth.getTokenInfo)('apiToken');
          if (apiToken) {
            console.log(apiToken);
            _this5.setfengkong(apiToken);
          } else {
            _this5.get_token();
          }
        }).catch(function () {
          _this5.$message({
            type: 'info',
            message: '已取消操作'
          });
          _this5.currentName = '';
          _this5.currentType = '';
          _this5.currentPrice = '';
        });
      }
    },
    getFengKongUser: function getFengKongUser() {
      var _this6 = this;
      (0, _request.default)({
        url: "/system/shopConfig/getFengKongUserInfo/",
        method: 'put',
        data: {
          shop_id: this.$user.data.shop,
          user_id: this.user_id
        }
      }).then(function (response) {
        if (response.data.data) {
          _this6.user_info = response.data.data;
          _this6.formInline.real_name = _this6.user_info.real_name;
          _this6.formInline.mobile = _this6.user_info.mobile;
          _this6.formInline.card_code = _this6.user_info.card_code;
          _this6.getMoneyList();
        } else {
          _this6.user_id = 0;
        }
        _this6.listLoading = false;
      });
    },
    // 格式化日期,需要加上时分秒的数据
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      var day = String(date.getDate()).padStart(2, '0');
      var hour = String(date.getHours()).padStart(2, '0');
      var minute = String(date.getMinutes()).padStart(2, '0');
      var second = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minute, ":").concat(second);
    },
    resetFilter: function resetFilter() {
      this.formInline.real_name = '';
      this.formInline.mobile = '';
      this.formInline.card_code = '';
      if (this.user_id > 0) {
        this.formInline.real_name = this.user_info.real_name;
        this.formInline.mobile = this.user_info.mobile;
        this.formInline.card_code = this.user_info.card_code;
      }
      this.formInline.start_time = '';
      this.formInline.end_time = '';
      this.formInline.remark = 'pay_risk_behavior,unify,court_detail_pro,apply_loan_c,apply_loan_c_money,financial_blacklist,zhengxin,gz,fengkong_default_money';
      this.datenum = [];
      this.getMoneyList();
    },
    // 获取划扣流水——done
    getMoneyList: function getMoneyList() {
      var _this7 = this;
      this.listLoading = true;
      // 王工封装
      // type 2 为支付宝账号流水
      (0, _request.default)({
        url: "/system/shopConfig/getFengKong/",
        method: 'put',
        data: {
          page: this.listQuery.page,
          page_size: this.listQuery.page_size,
          shop_id: this.$user.data.shop,
          remark: this.formInline.remark,
          mobile: this.formInline.mobile,
          real_name: this.formInline.real_name,
          card_code: this.formInline.card_code,
          start_time: this.start_time,
          end_time: this.end_time
        }
      }).then(function (response) {
        if (response.data) {
          _this7.moneyList = response.data.data;
        }
        _this7.listLoading = false;
      });
    },
    handleClick: function handleClick(e) {
      // remark 已是 xxx_money（如 apply_loan_c_money）时不再追加
      var type = e.remark || '';
      if (type === 'apply_loan_c') type = 'apply_loan_c_money';else if (type === 'financial_blacklist') type = 'financial_blacklist_money';else if (type && !String(type).endsWith('_money') && type !== 'fengkong_default') {
        type = type + '_money';
      }
      this.$router.push({
        name: 'ReportTable',
        query: {
          id: e.id,
          type: type
        }
      });
    },
    handleClick2: function handleClick2(e) {
      var type = e.remark || '';
      if (type && !String(type).endsWith('_money')) type = type + '_money';
      this.$router.push({
        name: 'fengkongDefault',
        query: {
          id: e.id,
          type: type
        }
      });
    },
    goto: function goto(url) {
      if (url == '/OrderHk/zhengxin') {
        this.$router.push({
          path: url,
          query: {
            user_id: this.user_id
          }
        });
      } else {
        if (url == '/OrderHk/gz') {
          this.$router.push({
            path: url,
            query: {
              user_id: this.user_id
            }
          });
        } else {
          this.$router.push({
            path: url
          });
        }
        //   this.$router.push({ path: url})
      }
    }
  }
};